import React from 'react';

import { PetQuotes } from 'src/features/pet/petQuotes/PetQuotes';

export const PetPlans = () => {
  return <PetQuotes isIssuer={true} />;
};
